import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { signInWithGoogleSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = loc.hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    (async () => {
      try {
        await signInWithGoogleSession(m[1]);
        toast.success("Connecté avec Google");
        nav("/dashboard", { replace: true });
      } catch {
        toast.error("Connexion Google échouée");
        nav("/login", { replace: true });
      }
    })();
  }, [loc.hash, nav, signInWithGoogleSession]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="glass rounded-xl px-6 py-4 text-sm text-slate-300">Connexion en cours…</div>
    </div>
  );
}
